import React, { useState, useEffect } from "react"
import { ToastProvider } from "react-toast-notifications"
import PageLoadNotification from "./components/ToastNotification/PageLoadNotification"
import ActionButton from "./components/ActionButton/ActionButton"

const DetectAdBlock = () => {
  const [adBlockDetected, setAdBlockDetected] = useState(false)

  useEffect(() => {
    // Call to bait function
    setAdBlockDetected(hasAdBlock)
  })

  const hasAdBlock = () => {
    let a = document.createElement("div")
    //Add space to div
    a.innerHTML = "&nbsp;"
    //Add lots of 'ad' bait classes
    a.className = "adsbox pub_300x250 pub_300x250m pub_728x90 text-ad textAd text_ad adglare ad-server"
    //Position blank pixel far off the users screen
    a.style = "width: 1px !important; height: 1px !important; position: absolute !important; left: -10000px !important; top: -1000px !important;"
    //Default hasAdBlock to false
    let r = false
    try {
      document.body.appendChild(a)
      let e = document.getElementsByClassName("adsbox")[0]
      //Check if the height of the blank pixel is 0, if it is 0, chances are ad blocker enabled
      if (e.offsetHeight === 0 || e.clientHeight === 0) r = true
      //Check if it has height, but doesn't have any styling attached
      if (window.getComputedStyle !== undefined) {
        let tmp = window.getComputedStyle(e, null)
        if (tmp && (tmp.getPropertyValue("display") === "none" || tmp.getPropertyValue("visibility") === "hidden")) r = true
      }
      //Remove pixel after check
      document.body.removeChild(a)
    } catch (e) {}
    return r
  }

  const refreshPage = () => {
    window.location.reload(false)
  }

  return (
    <div id="adblock-wrapper">
      {adBlockDetected ? (
        <ToastProvider autoDismiss={false} placement="top-center">
          <PageLoadNotification
            message={
              <>
                <p className="sans-serif mb2 mt0">Please turn off Adblocker to view ads then click the button to refresh</p>
                <ActionButton clickHandler={refreshPage} text={"Done"} />
              </>
            }
            type={"error"}
          />
        </ToastProvider>
      ) : null}
    </div>
  )
}

export default DetectAdBlock
